import { useState, useEffect } from 'react';
import './Library.scss';
import { useNavigate, useParams } from 'react-router';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Papa from 'papaparse';
import ReactMarkdown from 'react-markdown';
import Loader from '../../components/Loader';
import { isValidPhoneNumber } from 'libphonenumber-js';

const FORM_URL = 'https://hooks.zapier.com/hooks/catch/12344184/u858ktx/';

const Library = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const id = decodeURIComponent(useParams().id);
  const [data, setData] = useState();
  const [form, setForm] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSending, setSending] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const url =
      'https://docs.google.com/spreadsheets/d/e/2PACX-1vQWsIYoUIcsHlCYJm3gSK7HVP5M_txekJJgCQ1Gle__KhXHae3DJrc-tnhZW0Ces8uo_zFNmHOB6gNM/pub?gid=0&single=true&output=csv';
    fetch(url)
      .then(r => r.text())
      .then(csvText => {
        const result = Papa.parse(csvText, { header: true });
        const idTitle = window.location.pathname.replace('/profiles/', '');
        setData(result.data?.filter(item => item.tilte_for_url === idTitle)[0]);
        setIsLoading(false);
      });
  }, []);

  const handleChangeField = (name, value) => {
    const newData = { ...form };
    newData[name] = value;
    setForm(newData);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!isValidPhone(form?.phone)) return;

    setSending(true);
    const organization_name = document.querySelector('#organization_name').value;
    const phone = document.querySelector('#phone').value;
    const email = document.querySelector('#email').value;
    const contact_name = document.querySelector('#contact_name').value || '';
    const additional_comments = document.querySelector('#additional_comments').value || '';

    const values = {
      organization_name,
      contact_name,
      email,
      phone,
      additional_comments,
      sender_type: 'client',
    };

    fetch(`${FORM_URL}`, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify(values),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(() => {
      setIsSuccess(true);
      setSending(false);
    });
  };

  const isValidEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  const isValidPhone = phone => !phone?.trim() || isValidPhoneNumber(phone.trim(), 'US');

  const isDisabled = () => {
    return (
      !form?.email?.trim() ||
      !form?.organization_name?.trim() ||
      !form?.contact_name?.trim() ||
      !isValidEmail(form.email) ||
      !isValidPhone(form?.phone) ||
      isSending
    );
  };

  return (
    <div className='page'>
      <Header />
      <div className='libraryPage'>
        <div className='libraryBackLink' onClick={() => navigate('/profiles')}>
          <svg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M5.33073 9.99833L0.664062 5.33166M0.664062 5.33166L5.33073 0.664993M0.664062 5.33166H9.9974'
              stroke='#3A6376'
              stroke-width='1.33'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>
          Back to Candidates
        </div>
        {isLoading ? (
          <div className='loader'>
            <Loader />
          </div>
        ) : (
          <>
            <span className='libraryTitle'>{data?.title}</span>
            <span className='candidateDate'>{data?.date}</span>
            <div className='candidatePage'>
              <div className='candidatePageContent'>
                <ReactMarkdown>{data?.anon_cv_markdown}</ReactMarkdown>
              </div>
              <div>
                <div className='candidatePageForm'>
                  {isSuccess && (
                    <div className='mainFormSuccess'>
                      <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120' fill='none'>
                        <path
                          d='M45 60L55 70L75 50M110 60C110 87.6142 87.6142 110 60 110C32.3858 110 10 87.6142 10 60C10 32.3858 32.3858 10 60 10C87.6142 10 110 32.3858 110 60Z'
                          stroke='#14A852'
                          stroke-width='5'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        />
                      </svg>
                      <span className='mainFormSuccessTitle'>Request Submitted!</span>
                      <span className='mainFormSuccessText'>
                        We look forward to partnering with you. A team member will contact you shortly with next steps.
                      </span>
                    </div>
                  )}
                  <span className='candidatePageFormTitle'>Request Information</span>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Organization Name <span className='mainFormRequiredMark'>*</span>
                    </label>
                    <input
                      className='mainFormInput'
                      value={form?.organization_name}
                      id='organization_name'
                      onChange={e => handleChangeField('organization_name', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Contact Name <span className='mainFormRequiredMark'>*</span>
                    </label>
                    <input
                      className='mainFormInput'
                      value={form?.contact_name}
                      id='contact_name'
                      onChange={e => handleChangeField('contact_name', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>
                      Email Address <span className='mainFormRequiredMark'>*</span>
                    </label>
                    <input
                      className='mainFormInput'
                      value={form?.email}
                      id='email'
                      onChange={e => handleChangeField('email', e.target.value)}
                    />
                  </div>
                  <div className='mainFormField'>
                    <label className='mainFormLabel'>Phone Number </label>
                    <input
                      className='mainFormInput'
                      value={form?.phone}
                      id='phone'
                      onChange={e => handleChangeField('phone', e.target.value)}
                    />
                  </div>

                  <div className='mainFormTextarea'>
                    <label className='mainFormLabel'>Additional Comments</label>
                    <textarea
                      className='mainFormComment'
                      value={form?.additional_comments}
                      row={3}
                      id='additional_comments'
                      onChange={e => handleChangeField('additional_comments', e.target.value)}
                    ></textarea>
                  </div>
                  <span
                    className={cn('libraryListItemConterolOpen', isDisabled() && 'libraryListItemConterolOpenDisabled')}
                    onClick={handleSubmit}
                  >
                    Request Information
                  </span>
                </div>
                <div className='libraryContact'>
                  <span className='candidatePageFormTitle'>Need Consultation today?</span>
                  <a href='tel:+19133223478' className='libraryContactPhone'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                      <path
                        d='M22.0014 16.92V19.92C22.0025 20.1985 21.9455 20.4741 21.8339 20.7293C21.7223 20.9845 21.5587 21.2136 21.3535 21.4018C21.1483 21.5901 20.906 21.7335 20.6421 21.8227C20.3783 21.9119 20.0988 21.945 19.8214 21.92C16.7442 21.5856 13.7884 20.5341 11.1914 18.85C8.77523 17.3146 6.72673 15.2661 5.1914 12.85C3.50138 10.2412 2.44964 7.27097 2.1214 4.17997C2.09641 3.90344 2.12927 3.62474 2.2179 3.3616C2.30652 3.09846 2.44897 2.85666 2.63616 2.6516C2.82336 2.44653 3.0512 2.28268 3.30519 2.1705C3.55917 2.05831 3.83374 2.00024 4.1114 1.99997H7.1114C7.5967 1.9952 8.06719 2.16705 8.43516 2.48351C8.80313 2.79996 9.04348 3.23942 9.1114 3.71997C9.23802 4.68004 9.47285 5.6227 9.8114 6.52997C9.94594 6.8879 9.97506 7.27689 9.8953 7.65086C9.81555 8.02482 9.63026 8.36809 9.3614 8.63998L8.0914 9.90997C9.51495 12.4135 11.5879 14.4864 14.0914 15.91L15.3614 14.64C15.6333 14.3711 15.9766 14.1858 16.3505 14.1061C16.7245 14.0263 17.1135 14.0554 17.4714 14.19C18.3787 14.5285 19.3213 14.7634 20.2814 14.89C20.7672 14.9585 21.2108 15.2032 21.5279 15.5775C21.8451 15.9518 22.0136 16.4296 22.0014 16.92Z'
                        stroke='#3D424B'
                        stroke-width='2'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                    913-322-2245
                  </a>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Library;
